import React from 'react';
import classNames from 'classnames';

import moment from 'moment';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { CoreLink } from '@uncinc/react-drupal-core';
import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Breadcrumbs } from '../../../../components';
import { trackEvent } from '../../../../actions/UI';


import './style.scss';

const MemberFull = ({ entity, className }) => {
  const classes = classNames(className, 'MemberFull');

  const phone = entity.getIn(['field_telephone_number', 0, 'value']);
  const link = entity.getIn(['field_website', 0, 'uri']);
  const addressStreet = entity.getIn(['field_address', 0, 'address_line1']);
  const addressZipCode = entity.getIn(['field_address', 0, 'postal_code']);
  const addressLocality = entity.getIn(['field_address', 0, 'locality']);
  const cocNumber = entity.getIn(['field_coc_number', 0, 'value']);
  const email = entity.getIn(['field_email', 0, 'value']);
  const memberSince = moment(entity.getIn(['field_member_since', 0, 'value'])).format('DD-MM-YYYY');

  const snaObligated = entity.getIn(['field_sna_obligated', 0, 'value']);
  const snfObligated = entity.getIn(['field_snf_obligated', 0, 'value']);
  const zzpObligated = entity.getIn(['field_zzp_obligated', 0, 'value']);
  const snaCertified = entity.getIn(['field_sna_certified', 0, 'value']);
  const snfCertified = entity.getIn(['field_snf_certified', 0, 'value']);
  const zzpCertified = entity.getIn(['field_zzp_certified', 0, 'value']);

  const dispatch = useDispatch();

  const onMailClick = () => {
    dispatch(trackEvent('Mail', `Klik op "${email}"`, 'Mail', email));
  };

  return (
    <div className={classes}>
      <Container small>
        <Breadcrumbs includeCurrent />
        <div className="MemberFull__content">
          <h1 className="MemberFull__title">{entity.getIn(['title', 0, 'value'])}</h1>
          <div className="MemberFull__info">
            <div>
              {link && (
                <CoreLink className="MemberFull__info__link" to={entity.getIn(['field_website', 0, 'uri'])} title={entity.getIn(['field_website', 0, 'uri'])} />
              )}
              <div className="MemberFull__info__since">
                {memberSince && <div>Lid sinds: {memberSince}</div>}
                {cocNumber && <div>KvK nummer: {cocNumber}</div>}
              </div>
            </div>
            <div>
              {email && (
                <CoreLink onClick={onMailClick} to={`mailto:${email}`}>
                  <span className="icon-before icon-mail MemberFull__info__mail">{email}</span>
                </CoreLink>
              )}
              <div className="MemberFull__info__address__wrapper">
                <div className="icon-before icon-point" />
                <div className="MemberFull__info__address">
                  {addressStreet} <br />
                  {addressZipCode} {addressLocality}
                </div>
              </div>
            </div>
            <div>
              {phone && (
                <CoreLink to={`tel:${phone}`}>
                  <span className="icon-before icon-phone MemberFull__info__phone">{phone}</span>
                </CoreLink>
              )}
            </div>
          </div>
          {(snaObligated || snfObligated || zzpObligated) && (
            <div className="MemberFull__accreditation">
              <h2 className="MemberFull__accreditation__title">Keurmerken</h2>
            </div>
          )}
          {snaObligated && (
            <div className="MemberFull__accreditation">
              <h3>SNA Certificering</h3>
              <h3 className="MemberFull__accreditation__subtitle">
                {snaCertified ? i18next.t('certifications.sna_certified') : i18next.t('certifications.not_sna_certified')}
              </h3>
              <div className="MemberFull__accreditation__body">
                {i18next.t('certifications.sna_explanation_1')}&nbsp;
                <a href="https://www.normeringarbeid.nl/" target="_blank" rel="noopener noreferrer">
                  {i18next.t('certifications.sna_explanation_url_text')}
                </a>
                <br /><br />
                {i18next.t('certifications.sna_explanation_2')}
              </div>
            </div>
          )}

          {snfObligated && (
            <div className="MemberFull__accreditation">
              <h3>SNF Certificering</h3>
              <h3 className="MemberFull__accreditation__subtitle">
                {snfCertified ? i18next.t('certifications.snf_certified') : i18next.t('certifications.not_snf_certified')}
              </h3>
              <div className="MemberFull__accreditation__body MemberFull__accreditation__body--last">
                {i18next.t('certifications.snf_explanation_1')}&nbsp;
                <a href="https://www.normeringflexwonen.nl/" target="_blank" rel="noopener noreferrer">
                  {i18next.t('certifications.snf_explanation_url_text')}
                </a>
                <br /><br />
                {i18next.t('certifications.snf_explanation_2')}
              </div>
            </div>
          )}

          {zzpObligated && (
            <div className="MemberFull__accreditation">
              <h3>ZZP Certificering</h3>
              <h3 className="MemberFull__accreditation__subtitle">
                {zzpCertified ? i18next.t('certifications.zzp_certified') : i18next.t('certifications.not_zzp_certified')}
              </h3>
              <div className="MemberFull__accreditation__body MemberFull__accreditation__body--last">
                {i18next.t('certifications.zzp_explanation_1')}
                <br /><br />
                {i18next.t('certifications.zzp_explanation_2')}
              </div>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default MemberFull;
